import {useField, useFormikContext} from 'formik'
import React, {useCallback} from 'react'
import {TComponentRange} from './_types'

const ComponentRange: React.FC<TComponentRange> = ({
  article,
  min = 0,
  max = 10,
  step = 1,
  is_disabled,
  customHandler,
}) => {
  const [field, meta] = useField<number>(article)
  const {handleSubmit} = useFormikContext()

  const isError = Boolean(meta.touched && meta.error)
  const resolvedClassName = `componentRange form-range${isError ? ' is-invalid' : ''}`

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (customHandler) {
        customHandler(event)
      } else {
        field.onChange(event)
      }
    },
    [customHandler, field]
  )

  return (
    <div className='componentRangeWrapper'>
      <div className='d-flex justify-content-between mb-1'>
        <span className='text-muted'>{min}</span>
        <span className='text-muted'>{max}</span>
      </div>
      <input
        type='range'
        className={resolvedClassName}
        name={article}
        id={article}
        min={min}
        max={max}
        step={step}
        value={field.value ?? 0}
        onChange={handleChange}
        onBlur={field.onBlur}
        disabled={is_disabled}
      />
      <div className='text-center mt-2 fw-bold'>{field.value ?? 0}</div>

      {isError && <div className='invalid-feedback d-block'>{meta.error}</div>}
    </div>
  )
}

export default ComponentRange
